import { FC } from 'react';

import { useBaseProductQueryOld as useBaseProductQuery } from '../../hooks/queries/useBaseProductQueryOld';
import { useSelectedProductVariant } from '../../hooks/useSelectedProductVariant';

type Props = {
    baseProductCode: string;
};

/** @info Videoly script (injected through GTM) reads the data from these invisible divs and sends to Videoly service
 * @link https://support.videoly.co/151661-the-widget-knowledge-base/848519-sharing-product-information?from_search=133224403
 */
export const VideolyProductInformation: FC<Props> = ({ baseProductCode }) => {
    const { baseProduct, baseProductIsLoading } = useBaseProductQuery(baseProductCode);
    const productVariant = useSelectedProductVariant();
    const isLoading = baseProductIsLoading && !productVariant;

    return (
        !isLoading && (
            <>
                <div id="videoly-product-title" style={{ display: 'none' }}>
                    {baseProduct?.name}
                </div>
                <div id="videoly-product-id" style={{ display: 'none' }}>
                    {productVariant?.scalaId || baseProduct?.code?.replace(/^0+/, '')}
                </div>
                <div id="videoly-product-sku" style={{ display: 'none' }}>
                    {productVariant?.scalaId || baseProduct?.code?.replace(/^0+/, '')}
                </div>
                <div id="videoly-product-brand" style={{ display: 'none' }}>
                    {baseProduct?.brand}
                </div>
            </>
        )
    );
};
